import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'formatNumberValue',
    standalone: false
})
export class FormatNumberValuesPipe implements PipeTransform {
    // eslint-disable-next-line @angular-eslint/prefer-inject
    constructor(private translate: TranslateService) {}

    transform(value: number): number {
        const roundedUpValue = Math.round(value * 100) / 100;

        return roundedUpValue;
    }
}
